import * as PIXI from "pixi.js";
import { TimeCountManager } from "../managers/timeCountManager";

export type SetupTimeCounterProps = Readonly<{
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  textStyle: PIXI.TextStyle;
  timeCountManager: TimeCountManager;
  x: number;
  y: number;
}>;

export function setupTimeCounter({
  parent,
  ticker,
  textStyle,
  timeCountManager,
  x,
  y,
}: SetupTimeCounterProps) {
  const counter = new PIXI.Text("", textStyle);
  counter.x = x;
  counter.y = y;
  const onTick = () => {
    if (isFinite(timeCountManager.restMs)) {
      const restSeconds = Math.round(timeCountManager.restMs / 1000);
      counter.text = `${restSeconds}`;
    } else {
      counter.text = "∞";
    }
  };
  parent.addChild(counter);
  ticker.add(onTick);

  const dispose = () => {
    parent.removeChild(counter);
    ticker.remove(onTick);
  };

  return dispose;
}
